import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { Screen, TopBar, Loader } from "@/components/ui";
import { useAuth } from "@/context/AuthContext";
import { crystalsApi } from "@/data/api";

export default function AdminCrystalsList() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      crystalsApi.adminList(token, search.trim()).then((r) => setItems(r.items || [])).catch(() => {}).finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [token, search]);

  return (
    <Screen>
      <TopBar title="Crystal School" subtitle="Manage the crystal library" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 40px" }}>
        <button data-testid="new-crystal-button" className="pressable" onClick={() => navigate("/admin/crystal-edit")} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: colors.brand, color: colors.onBrand, border: "none", borderRadius: 12, padding: "13px", marginBottom: 14, cursor: "pointer", fontSize: 14, fontWeight: 700, fontFamily: fonts.text }}>
          <Icon name="plus" size={16} color={colors.onBrand} />New crystal
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 10, background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 12, padding: "0 12px", height: 46, marginBottom: 16 }}>
          <Icon name="search" size={18} color={colors.muted} />
          <input data-testid="crystal-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search crystals..." style={{ flex: 1, border: "none", outline: "none", background: "transparent", color: colors.onSurface, fontSize: 15, fontFamily: fonts.text }} />
        </div>
        {loading ? <Loader /> : items.map((c) => (
          <button key={c.id} data-testid={`crystal-admin-row-${c.slug}`} className="pressable" onClick={() => navigate(`/admin/crystal-edit?id=${c.id}`)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 14, padding: 14, marginBottom: 10, cursor: "pointer", textAlign: "left" }}>
            <div style={{ flex: 1 }}>
              <div style={{ color: colors.onSurface, fontSize: 15, fontWeight: 700, fontFamily: fonts.text }}>{c.name}{c.hidden ? " (hidden)" : ""}</div>
              <div style={{ color: colors.muted, fontSize: 12, marginTop: 2, fontFamily: fonts.text }}>{(c.intentions || []).slice(0, 3).join(", ")}</div>
            </div>
            <Icon name="chevron-right" size={20} color={colors.muted} />
          </button>
        ))}
      </div>
    </Screen>
  );
}
